import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Nav } from 'react-bootstrap';
import { TabContent } from './TabGroupContent';
export const PillsLayout = ({ nav, tabs }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Nav, Object.assign({ variant: 'pills', className: 'flex-column tab-nav-pills' }, { children: nav })), _jsx(TabContent, { tabs: tabs })] }));
};
